import { ACTION_CODE, IAccessRightProfile } from "fieldpro-tools";

export { LOGOUT_REQUEST_SUCCESS } from "../../containers/authentication/redux/actionTypes";
// action type that specifies this is the first app login
export const APP_FIRST_LOGIN = "APP_LOGIN_SUCCESS";
export const APP_ADD_NOTIFICATION = "APP_ADD_NOTIFICATION";
export const APP_REMOVE_NOTIFICATION = "APP_REMOVE_NOTIFICATION";
export const APP_CLEAN_NOTIFICATION = "APP_CLEAN_NOTIFICATION";
export const OPEN_WARNING_MODAL = "OPEN_WARNING_MODAL";
export const CLOSE_WARNING_MODAL = "CLOSE_WARNING_MODAL";
export const SHOW_UPDATE_DIALOG = "SHOW_UPDATE_DIALOG";
export const HIDE_UPDATE_DIALOG = "HIDE_UPDATE_DIALOG";
export const SHOW_MIGRATION_DIALOG = "SHOW_MIGRATION_DIALOG";
export const HIDE_MIGRATION_DIALOG = "HIDE_MIGRATION_DIALOG";
export const TOGGLE_UPDATE_DIALOG = "TOGGLE_UPDATE_DIALOG";
export const TOGGLE_MIGRATION_DIALOG = "TOGGLE_MIGRATION_DIALOG";
export const SHOW_REFRESH_MODAL = "SHOW_REFRESH_MODAL";
export const HIDE_REFRESH_MODAL = "HIDE_REFRESH_MODAL";
export const TOGGLE_REFRESH_MODAL = "TOGGLE_REFRESH_MODAL";
export const SET_SIDEBAR_EXPANDED = "SET_SIDEBAR_EXPANDED";

export type TAvailableActions = Partial<{
  [key in keyof typeof ACTION_CODE]: boolean;
}>;

export type TAccessRightProfile = IAccessRightProfile;
